export const useSaleListingAgreementPartiesUtils = () => {
  const extractPendingReviewApprovals = (data) => {
    const sellers = data?.relationships?.saleListingAgreementSellers?.data || [];
    const sellersInfo = sellers
      .map((seller) => ({
        id: seller.id,
        name: seller?.attributes?.name || "Unknown",
        role: "vendeur",
        approval: seller?.attributes?.riskScoringReviewApproval ?? null,
      }))
      .filter((seller) => seller.approval !== true);

    const buyersInfo = [];
    const properties = data?.relationships?.saleListingAgreementProperties?.data || [];

    properties.forEach((slap) => {
      const offers = slap?.relationships?.property?.data?.relationships?.purchaseOffers?.data || [];
      offers.forEach((offer) => {
        const buyers = offer?.relationships?.buyers?.data || [];
        buyers.forEach((buyer) => {
          if (buyer?.attributes?.riskScoringReviewApproval !== true) {
            buyersInfo.push({
              id: buyer.id,
              name: buyer?.attributes?.name || "Unknown",
              role: "acquéreur",
              approval: buyer?.attributes?.riskScoringReviewApproval ?? null,
            });
          }
        });
      });
    });
    return [...sellersInfo, ...buyersInfo];
  };

  return {
    extractPendingReviewApprovals,
  };
};
